import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { enableManyConsistencyCheckRanMonitoring } from '@api/consistencyCheck';

import { TConsistencyCheckRanGetAvailableTemplatesDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONSISTENCY_RAN_ENABLE_MANY_MONITORING, CONSISTENCY_RAN_TABLE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateConsistencyCheckRanEnableManyMonitoring {
	enableManyMonitoring: UseMutateFunction<any, any, TConsistencyCheckRanGetAvailableTemplatesDTO, any>;
	isLoadingEnableManyMonitoring: boolean;
}

export const useMutateConsistencyCheckRanEnableManyMonitoring = ({
	onSuccess,
}: IOnSuccess): IUseMutateConsistencyCheckRanEnableManyMonitoring => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<TConsistencyCheckRanGetAvailableTemplatesDTO>({
		mutationKey: [CONSISTENCY_RAN_ENABLE_MANY_MONITORING],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: enableManyConsistencyCheckRanMonitoring,
		onSuccess: () => {
			onSuccess?.();

			dispatch(setSnackbar({
				message: responseMessages.enableMonitoringConsistencyCheckRanTemplate,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([CONSISTENCY_RAN_TABLE])];
		},
	});

	return {
		enableManyMonitoring: mutate,
		isLoadingEnableManyMonitoring: isLoading,
	};
};
